import styled, { css } from 'styled-components';
import { Text } from '@lmn/design-system';
import { ellipsis } from '@/app/components/search/styles/mixins.ts';
import {
  trustYouExcellent,
  trustYouFair,
  trustYouGood,
  trustYouPoor,
  trustYouVeryGood,
} from '../../../../styles/colors';

export const RatingsContainer = styled.div<{ isOverlay: boolean; $hasCertificationBelow?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  color: ${({ theme }) => theme.kallisto.color.text.static.textPrimary};
  max-width: 100%;

  margin-bottom: ${({ $hasCertificationBelow }) => ($hasCertificationBelow ? '8px' : '12px')};

  ${({ isOverlay, $hasCertificationBelow }) =>
    !isOverlay &&
    !$hasCertificationBelow &&
    css`
      @media (min-width: 768px) {
        margin-bottom: 16px;
      }
    `}
`;

export const Separator = styled.div<{ height?: number; asBr?: boolean }>`
  width: 1px;
  background-color: ${({ theme }) => theme.kallisto.color.common.black[100]};
  height: 20px;
  margin: 0 8px;

  ${({ height }) => {
    if (height) {
      return css`
        height: ${height}px;
        margin: 0 6px;
      `;
    }

    return css``;
  }}
`;

export const Score = styled(Text)`
  border-radius: 4px;
  color: ${({ theme }) => theme.kallisto.color.background.static.backgroundPage};
  ${({ theme }) => theme.kallisto.mixins.font('Title5')};
  height: 20px;
  font-size: 14px;
  min-width: 30px;
  max-width: 36px;
  padding: 2px 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;

  &.no-rating {
    background: #dadada;
  }

  &.excellent {
    background: ${trustYouExcellent};
  }

  &.very-good {
    background: ${trustYouVeryGood};
  }

  &.good {
    background: ${trustYouGood};
  }

  &.pleasant {
    background: ${trustYouFair};
  }

  &.poor {
    background: ${trustYouPoor};
  }
`;

export const ReviewsTrigger = styled.span`
  min-width: 0;
`;

export const ReviewsNumber = styled(Text)<{ $hasLink: boolean }>`
  color: ${({ theme }) => theme.kallisto.color.text.static.textPrimary};
  ${ellipsis};

  ${({ $hasLink }) =>
    $hasLink &&
    css`
      cursor: pointer;

      span {
        text-decoration: underline;
        text-decoration-style: dotted;
        text-decoration-thickness: 2px;
        text-underline-offset: 3px;
        text-decoration-color: ${({ theme }) => theme.kallisto.color.text.static.textPrimary};
      }
    `}
`;

export const ReviewsTitle = styled(Text)`
  white-space: nowrap;
  color: ${({ theme }) => theme.kallisto.color.text.static.textPrimary};
  font-weight: bold;
`;
